import Clipboard from 'clipboard';
import * as angular from 'angular';
import { getUrlParam } from '../../../company/sharing-center/shared-authenticators/manage/getUrlParam';
import { passwordGrade } from '../../../../../util/password-strength';

export class Controller {

    /** @ngInject */
    constructor($state, $scope ,Alert, ConfirmDeleteModal, ConfirmModal, Authenticator, PasswordManagers, ConfirmConvertModal, DestructiveOperationModal, $uibModal) {
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.Authenticator = Authenticator;
        this.PasswordManagers = PasswordManagers;
        this.$state=$state;
        this.$scope=$scope;
        this.ConfirmConvertModal=ConfirmConvertModal;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.$uibModal = $uibModal;
    }

    $onInit() {
        this.tooltipTemplate = require('../../../company/sharing-center/secret-tooltip.html');
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })

        if(this.publicUserAccount==null){
             this.$state.go('^');
        }
        this.$account = {
            ...this.publicUserAccount,
            digits: 6,
            algorithm: 'SHA1',
            secret: null,
        };

        if (this.publicUserAccount.authenticator && this.publicUserAccount.serviceKey) {
            const url = this.publicUserAccount.serviceKey.publicServiceKey;
            this.$account = {
                ...this.$account,
                digits: +getUrlParam(url, 'digits', 6),
                algorithm: getUrlParam(url, 'algorithm', 'SHA1'),
                secret: getUrlParam(url, 'secret'),
            };
        }



        this.account = JSON.parse(JSON.stringify(this.$account));
        this.passGrade=passwordGrade(this.account.password);
        this.publicServicesWithSso$.get().then(items => this.publicServices=items);
        this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
    
        this.isCustom = this.$account.publicService.slug == 'other';
    }

    saveIcon(iconFile) {
        const formData = new FormData();
        formData.append('iconFile', iconFile);
        return this.Authenticator.uploadCustomIcon(
            {
                publicUserAccountId: this.account.id,
            },
            formData
        )
            .$promise
            .then((data) => {
                this.account.customIcon = data.customIcon;
                this.Alert('success', 'user.public-user-accounts.edit.updated');
            });
    }

    resetIcon() {
        return this.ConfirmModal({
            messageKey:'Custom icon will be deleted and default icon will be used. Do you want to continue?',
            titleKey:'Confirm Delete'
        })
        .then(() =>
            this.Authenticator.deleteCustomIcon(
                    {
                        publicUserAccountId: this.account.id,
                    }
                )
                .$promise
                .then(() => {
                    this.account.customIcon = null;
                    this.Alert('success', 'user.public-user-accounts.edit.updated');
                })
        )
    }
    
    changePassGrade(){
		this.passGrade=passwordGrade(this.account.password);
	}

    notModified() {
        if (this.$account.publicService.id === this.account.publicService.id) {
            this.account.publicService = this.$account.publicService;
        }
        return angular.equals(this.$account, this.account);
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.publicServices.find(i => i.slug === "other");
    }

    serviceSelected(service) {
        this.account.publicService = service;
        if (service.slug !== "other") {
            this.account.customAuthenticator = null;
        }
    }

    remove() {
        this.isRemoving = true;
        if (this.$account.authenticator) {
            this.DestructiveOperationModal({
                titleKey: 'authenticators.messages.delete_authenticator_title',
                textKey: 'authenticators.messages.warning',
                http: {method: 'DELETE', url: `app/rest/authenticators/${this.account.id}`}
            }).then(() => {
                this.$state.go('^', {}, {reload: '^'});
                this.Alert('success', 'authenticators.messages.delete');
                this.isRemoving = false;
            })
            .finally(() => this.isRemoving = false);
        } else {
            this.$uibModal
            .open({component: 'userPasswordManagerConfirmRemove'}).result
            .then(() => {
                this.PasswordManagers.remove(this.account.id).then(() => {
                    this.Alert('success', 'authenticators.messages.deleteLoginItem');
                    this.$state.go('^', {}, {reload: '^'});
                });
            }).finally(() => this.isRemoving = false);
        }
    }

    save() {
        this.isSaving = true;
        if (this.$account.authenticator && !this.account.authenticator) {
            this.ConfirmConvertModal('user.public-user-accounts.edit.convert-auth-to-pass')
                .then(() => this.performSave())
                .finally(() => this.isSaving = false);
        } else {
           this.performSave(); 
        }

    }

    performSave() {
        let customServiceName;
        if (this.account.customAuthenticator) {
            customServiceName = this.account.customAuthenticator.customAuthenticatorName;
        }
        let publicServiceKey;
        if (this.account.authenticator) {
            publicServiceKey = generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.account.secret,
                    this.account.digits,
                    this.account.algorithm,
                );
        }
        let serviceLoginUrl;
        if (this.account.customLoginUrl) {
            serviceLoginUrl = this.account.customLoginUrl.serviceLoginUrl;
        }
        

        this.Authenticator.edit(
            {
                publicServiceId: this.account.publicService.id,
            },
            {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                note: this.account.note,
                serviceLoginUrl: serviceLoginUrl,
                enabled2fa: this.account.authenticator,
                customServiceName: customServiceName,
                publicServiceKey: publicServiceKey,
            }
        )
            .$promise
            .then(account => {
                this.$state.go('.', {}, { reload: '^' });
                this.Alert('success', 'user.public-user-accounts.edit.updated');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || this.notModified();
    }

    convertDisabled(form){
		return this.isSaving || this.isRemoving;
	}

    convert() {
        this.account.authenticator = !this.account.authenticator;
    }

    createCopy() {
        let copyAccount = {
            username: this.publicUserAccount.username,
            password: this.publicUserAccount.password,
            note: this.publicUserAccount.note,
            publicService: this.publicServices.find(i => i.slug === "other"),
            customServiceName: this.getCopyServiceName(),
            serviceLoginUrl: this.publicUserAccount.publicService.slug === 'other' ? this.publicUserAccount.customLoginUrl : this.publicUserAccount.publicService.serviceUrl
        };

        if(this.publicUserAccount.authenticator) {
            const url = this.publicUserAccount.serviceKey.publicServiceKey;
            copyAccount = {
                ...copyAccount,
                algorithm: getUrlParam(url, 'algorithm', 'SHA1'),
                digits: +getUrlParam(url, 'digits', 6),
                secret: getUrlParam(url, 'secret'),
            }
        }

        let type = this.publicUserAccount.authenticator ? 'authenticator' : 'password-manager';
        this.$state.go("user.public.user-accounts.add",{type:type, copyAccount:copyAccount});
    }

    getCopyServiceName() {
        let currentServiceName = this.publicUserAccount.publicService.slug === 'other' ? this.publicUserAccount.customAuthenticator.customAuthenticatorName : this.publicUserAccount.publicService.serviceName;
        let customServiceNames = this.publicUserAccounts.filter(account => account.username === this.publicUserAccount.username && account.publicService.slug === 'other' && account.customAuthenticator != null).map(item => {
            return item.customAuthenticator.customAuthenticatorName;
        });
        currentServiceName = currentServiceName.indexOf(' Copy') !== -1 ? currentServiceName.substring(0, currentServiceName.indexOf(' Copy')) : currentServiceName;
        let copyServiceName = currentServiceName + ' Copy';
        if (customServiceNames.indexOf(copyServiceName) === -1) {
            return copyServiceName;
        }
        
        let i = 1;
        while (customServiceNames.indexOf(copyServiceName + ' ' + i) !== -1) {
            i++;
        }
        return copyServiceName + ' ' + i;
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/edit/edit-public-user-account.controller.js